import React, {useEffect, useState} from 'react'
import {Button} from '../../../../../core/shared/Button'
import {currencyFormat} from '../../../../../utils/currency-format'
import {getPriceForCountry} from '../../../utils/getPriceForCountry'
import {
  WEBSITE_DESIGN_FEE_PLAN,
  getWebsiteDesignFeePrice,
} from '../../../utils/websiteDesignFee'
import {WebsiteSettingsModal} from '../../WebsiteSettingsModal'
import {
  AddToOrderRow,
  PanelContainer,
  EntitlementsList,
  EntitlementsTitle,
  EntitlementItem,
} from '../ProductPlanSelector.styles'

// Standalone form of Professionally Designed Website (addon-5-website_difm).
// Opens the "existing site?" modal as soon as this panel mounts (mirrors the
// legacy centers-and-apps.js handleSelect behavior), and — unless the answer
// waives it — adds the Website Design Fee alongside the add-on in the same
// Add to Order action (via resolveItemsAfterAdd's autoAddOneTimeFees rule).
export function WebsiteAddonPanel({
  plan,
  selectedCountry,
  itemInOrder,
  groupPlanCodes,
  groupId,
  onAddProduct,
  onClose,
}) {
  const isItemInOrder = Boolean(itemInOrder)
  const [isModalOpen, setIsModalOpen] = useState(true)
  const [websiteTransfer, setWebsiteTransfer] = useState({
    hasExistingWebsite: false,
    domain: null,
    isDomainValid: false,
  })

  useEffect(() => {
    setIsModalOpen(true)
  }, [])

  const isFeeWaived = websiteTransfer.isDomainValid
  const feePrice = getWebsiteDesignFeePrice(selectedCountry)

  const handleAddToOrder = () => {
    const product = {
      productId: plan.code,
      productCode: plan.code,
      name: plan.name,
      price: getPriceForCountry(plan.currencies, selectedCountry),
      quantity: 1,
      type: 'addon',
      billingFrequency:
        plan.productBillingType === 'Annual' ? 'annual' : 'monthly',
      configuredOptions: {
        hasExistingWebsite: websiteTransfer.hasExistingWebsite,
        domain: websiteTransfer.domain,
        isDomainValid: websiteTransfer.isDomainValid,
      },
      excludes: plan.excludes ?? [],
      autoAddCenters: plan.autoAddCenters ?? [],
      autoAddOneTimeFees: isFeeWaived ? [] : [WEBSITE_DESIGN_FEE_PLAN],
      disableApps: plan.disableApps ?? [],
      disableCenters: plan.disableCenters ?? [],
      maxQty: plan.maxQty ?? null,
      parentProduct: plan.parentProduct,
    }

    onAddProduct(product, groupPlanCodes, groupId)
    onClose()
  }

  return (
    <PanelContainer>
      <WebsiteSettingsModal
        isOpen={isModalOpen}
        onContinue={result => {
          setWebsiteTransfer(result)
          setIsModalOpen(false)
        }}
      />
      {!isFeeWaived && (
        <>
          <EntitlementsTitle>Fees</EntitlementsTitle>
          <EntitlementsList>
            <EntitlementItem>
              <label style={{cursor: 'default'}}>
                <input type="checkbox" checked disabled />{' '}
                {WEBSITE_DESIGN_FEE_PLAN.name} (
                {currencyFormat(feePrice, selectedCountry)})
              </label>
            </EntitlementItem>
          </EntitlementsList>
        </>
      )}
      <AddToOrderRow>
        <Button
          type="button"
          variant="action-orange"
          size="sm"
          onClick={handleAddToOrder}
        >
          {isItemInOrder ? 'Update Order' : 'Add to Order'}
        </Button>
      </AddToOrderRow>
    </PanelContainer>
  )
}
